import { useState, useEffect } from "react";
import useEsri from "../hooks/useEsri";
import { getQueryLayerUniqueCode } from "../utils";

const useDownloadData = ({
  gpServiceInfo,
  fileType,
  GPService,
  getSelectedQueryLayer,
}) => {
  const [error, setError] = useState(false);
  const [downloadLink, setDownloadLink] = useState();
  const { geoProcessor } = useEsri();

  useEffect(() => {
    if (!fileType || !gpServiceInfo || !getSelectedQueryLayer) {
      return;
    }
    const downloadFileService = async (csvFileService) => {
      const gpService = await geoProcessor(GPService.DOWNLOAD_LAYER_URL);
      const uniqueCodeSlug = getQueryLayerUniqueCode(getSelectedQueryLayer);
      const { token, service, service_name, unique_id } = gpServiceInfo;

      const outputNameWithTimeStamp = `${service_name
        .replace(/ /g, "_")
        .toLowerCase()}_${new Date().getTime()}`;
      const params = {
        inputLayers: [
          { url: service, filter: uniqueCodeSlug + `'${unique_id}'` },
        ],
        clip: false,
        extent: "",
        outputName:
          '{"itemProperties":{"title": "' + outputNameWithTimeStamp + '"}}',
        dataFormat: fileType,
      };

      try {
        const { jobId } = await gpService.submitJob(params);
        const GPJobCompletEvent = await gpService.waitForJobCompletion(jobId);
        if (GPJobCompletEvent.jobStatus === "job-succeeded") {
          const GPResultResponse = await gpService.getResultData(
            GPJobCompletEvent.jobId,
            "contentID"
          );

          // CSV file encoding download fix (ticket AQA-609)
          if (GPResultResponse.value.itemId && fileType === "CSV") {
            const csvDownloadUrl = await csvFileService(
              GPResultResponse.value.itemId
            );
            setDownloadLink(csvDownloadUrl);
            return;
          }
          //end

          if (GPResultResponse.value.url) {
            const downloadUrl = `${GPResultResponse.value.url}/data?token=${token}`;
            setDownloadLink(downloadUrl);
          }
        }
      } catch (e) {
        console.error("error:", e);
        setError(true);
      }
    };

    const csvFileService = async (itemId) => {
      const gpEncodingCsvService = await geoProcessor(
        GPService.DOWNLOAD_CSV_LAYER_URL
      );
      const params = {
        csv_file_id: "" + itemId + "",
      };
      try {
        const { results } = await gpEncodingCsvService.execute(params);
        if (results[0]["value"]["url"]) return results[0]["value"]["url"];
      } catch (e) {
        console.error("error:", e);
        setError(true);
      }
    };

    downloadFileService(csvFileService);

    return () => {
      /* clean up */
    };
  }, [fileType, gpServiceInfo, geoProcessor, GPService, getSelectedQueryLayer]);

  return {
    error,
    downloadLink,
  };
};

export default useDownloadData;
